import { render } from "./designations-modal.vue?vue&type=template&id=03242adf"
import script from "./designations-modal.vue?vue&type=script&lang=js"
export * from "./designations-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__